import { LOAD_VISIBLE_PRODUCTS, LOAD_REG_CART_VISIBLE_PRODUCTS,
  RESET_VISIBLE_PRODUCTS, LOAD_VISIBLE_SESSION_PRODUCTS, LOAD_VISIBLE_PRODUCTS_BY_REG_TYPE } from './actionTypes';
import { UPDATE_REG_CART_SUCCESS } from './registrationForm/regCart/actionTypes';
import { getRegistrationTypeId as getCurrentRegistrationTypeId,
  getSelectedAdmissionItem as getCurrentSelectedAdmissionItem,
  getEventRegistration as getCurrentEventRegistration,
  getRegistrationTypeIdForAgenda } from './selectors/currentRegistrant';
import { getRegistrationPathIdOrNull as getCurrentRegistrationPathId } from './selectors/currentRegistrationPath';
import { getEventRegistration, getPrimaryRegistrationId, getRegistrationTypeId, getRegistrationPathId,
  getSelectedAdmissionItem } from './registrationForm/regCart/selectors';
import { getRegCart } from './selectors/shared';
import { keys, map, get } from 'lodash';

const initialState = { };

export function populateVisibleProducts(eventRegistrationId, widgetType = 'Sessions') {
  return async (dispatch, getState) => {
    const {
      accessToken,
      userSession: { eventId },
      eventSnapshotVersion,
      clients: { eventSnapshotClient }
    } = getState();

    const regCart = getRegCart(getState());
    const eventRegistration = eventRegistrationId ?
      getEventRegistration(regCart, eventRegistrationId) :
      getCurrentEventRegistration(getState());
    const registrationTypeId = eventRegistrationId ?
      getRegistrationTypeId(regCart, eventRegistrationId) :
      getCurrentRegistrationTypeId(getState());
    const registrationPathId = eventRegistrationId ?
      getRegistrationPathId(regCart, eventRegistrationId) :
      getCurrentRegistrationPathId(getState());
    const selectedAdmissionItem = eventRegistrationId ?
      getSelectedAdmissionItem(regCart, eventRegistrationId) :
      getCurrentSelectedAdmissionItem(getState());
    const admissionId = selectedAdmissionItem ? selectedAdmissionItem.productId : null;
    const attendeeType = eventRegistration.attendeeType;
    const primaryEventRegistrationId = (attendeeType === 'GUEST') ?
      eventRegistration.primaryRegistrationId : getPrimaryRegistrationId(regCart);
    const primaryEventRegistration = getEventRegistration(regCart, primaryEventRegistrationId);
    const primaryRegistrationTypeId = primaryEventRegistration.registrationTypeId;

    const visibleProducts = await eventSnapshotClient.getVisibleProducts(accessToken, eventId,
      { version: eventSnapshotVersion, registrationTypeId, registrationPathId, primaryRegistrationTypeId,
        admissionId, attendeeType, widgetType });
    dispatch({
      type: LOAD_VISIBLE_SESSION_PRODUCTS,
      payload: {
        eventRegistrationId: eventRegistration.eventRegistrationId,
        visibleProducts
      }
    });
  };
}

export function populateAllProductsByRegistrationType(widgetType, widgetId = null) {
  return async (dispatch, getState) => {
    const {
      accessToken,
      userSession: { eventId },
      eventSnapshotVersion,
      clients: { eventSnapshotClient },
      visibleProducts: existingVisibleProducts
    } = getState();
    const widget = widgetId != null ? `${widgetType}:${widgetId}` : widgetType;
    const calculatedRegistrationTypeId = getRegistrationTypeIdForAgenda(getState());
    if (get(existingVisibleProducts, [widget, calculatedRegistrationTypeId, 'visibleProducts'])) {
      return;
    }
    const visibleProducts = await eventSnapshotClient.getVisibleProducts(accessToken, eventId,
      { version: eventSnapshotVersion, registrationTypeId: calculatedRegistrationTypeId,
        widgetType, widgetId });
    dispatch({
      type: LOAD_VISIBLE_PRODUCTS_BY_REG_TYPE,
      payload: {
        widget,
        calculatedRegistrationTypeId,
        visibleProducts
      }
    });
  };
}

export function populateAllProducts(widgetType, widgetId = null) {
  return async (dispatch, getState) => {
    const {
      accessToken,
      userSession: { eventId },
      eventSnapshotVersion,
      clients: { eventSnapshotClient },
      visibleProducts: existingVisibleProducts
    } = getState();
    const widget = widgetId != null ? `${widgetType}:${widgetId}` : widgetType;
    if (get(existingVisibleProducts, [widget, 'visibleProducts'])) {
      return;
    }
    const selectedAdmissionItem = getCurrentSelectedAdmissionItem(getState());
    const admissionId = selectedAdmissionItem ? selectedAdmissionItem.productId : null;
    const visibleProducts = await eventSnapshotClient.getVisibleProducts(accessToken, eventId,
      { version: eventSnapshotVersion, widgetType, widgetId, admissionId });
    dispatch({
      type: LOAD_VISIBLE_PRODUCTS,
      payload: {
        widget,
        visibleProducts
      }
    });
  };
}

export function populateRegCartVisibleProducts() {
  return async (dispatch, getState) => {
    const {
      accessToken,
      userSession: { eventId },
      eventSnapshotVersion,
      clients: { eventSnapshotClient }
    } = getState();

    const regCart = getRegCart(getState());

    const visibleProducts = await eventSnapshotClient.getRegCartVisibleProducts(accessToken, eventId,
      { version: eventSnapshotVersion, regCartId: regCart.regCartId });
    dispatch({
      type: LOAD_REG_CART_VISIBLE_PRODUCTS,
      payload: visibleProducts
    });
  };
}

export function resetVisibleProducts() {
  return async (dispatch) => {
    dispatch({
      type: RESET_VISIBLE_PRODUCTS
    });
  };
}

/**
* Reducer to keep track of visible products per registrant
*/
export default function visibleProductsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_VISIBLE_SESSION_PRODUCTS:
      return {
        ...state,
        Sessions: {
          ...state.Sessions,
          [action.payload.eventRegistrationId]: {
            ...action.payload.visibleProducts
          }
        }
      };
    case LOAD_VISIBLE_PRODUCTS_BY_REG_TYPE:
      return {
        ...state,
        [action.payload.widget]: {
          ...state[action.payload.widget],
          [action.payload.calculatedRegistrationTypeId]: {
            ...action.payload.visibleProducts
          }
        }
      };
    case LOAD_VISIBLE_PRODUCTS:
      return {
        ...state,
        [action.payload.widget]: {
          ...action.payload.visibleProducts
        }
      };
    case LOAD_REG_CART_VISIBLE_PRODUCTS:
      return {
        ...state,
        Sessions: {
          ...action.payload
        }
      };
    case UPDATE_REG_CART_SUCCESS: {
      // check if any event reg has been removed and remove visible products for that event reg
      const eventRegistrationIdsToRemove = [];
      // get the regCart with unsaved changes for group member to prevent page flashing products.
      const savedRegCart = action.payload.regCart;
      const widgetType = 'Sessions';
      keys(state[widgetType]).forEach((eventRegistrationId) => {
        if (!keys(savedRegCart.eventRegistrations)
          .find(regCartEventRegistrationId => regCartEventRegistrationId === eventRegistrationId)) {
          eventRegistrationIdsToRemove.push(eventRegistrationId);
        }
      });
      const remainedVisibleProducts = { ...state[widgetType] };
      map(eventRegistrationIdsToRemove, eventRegistreationIdToRemove =>
        delete remainedVisibleProducts[eventRegistreationIdToRemove]);
      return {
        ...state,
        [widgetType]: { ...remainedVisibleProducts }
      };
    }
    case RESET_VISIBLE_PRODUCTS:
      return initialState;
    default:
      return state;
  }
}
